import { useState, useEffect, useCallback } from 'react';

const slides = [
  '/photo-1.png',
  '/photo-2.png',
  '/photo-3.png',
  '/photo-4.png',
  '/IMG_3816.jpeg',
  '/ecd9e08a-03f6-4f97-b991-3cf9da16001b.jfif',
  '/4d302aff-bae0-4a36-8459-0281d2abf2a5.jfif',
  '/4d302aff-bae0-4a36-8459-0281d2abf2a5-2.jfif',


];

export default function Welcome() {
  const [current, setCurrent] = useState(0);
  const total = slides.length;

  const showSlide = useCallback((i: number) => {
    setCurrent(i);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent(prev => (prev + 1) % total);
    }, 5000);
    return () => clearInterval(interval);
  }, [total]);

  return (
    <section id="welcome">
      <div className="welcome" style={{
        display: 'grid', gridTemplateColumns: '1fr 1.2fr',
        gap: '5rem', alignItems: 'center',
        maxWidth: 1300, margin: '0 auto',
      }}>
        <div className="welcome-text">
          <div className="section-eyebrow">A Welcome to All</div>
          <h2 className="section-title">Half a century of <em>laughter, learning and life-long friendship.</em></h2>
          <div>
            <p style={{
              fontFamily: "'Cormorant Garamond', serif", fontSize: '1.25rem',
              lineHeight: 1.7, color: '#3a3a3a', marginBottom: '1.2rem',
            }}>
              For fifty years, Queen of Angels has been more than a school. It has been a meeting of minds, a forging of friendships and the place where generations of children took their very first steps into learning, faith and lifelong friendship.
            </p>
            <p style={{
              fontFamily: "'Cormorant Garamond', serif", fontSize: '1.25rem',
              lineHeight: 1.7, color: '#3a3a3a', marginBottom: '1.2rem',
            }}>
              This site is your invitation in. Whether you were a pupil here in the seventies, are a parent at the school gates today, or have watched our doors come and go from a home on the same road — you are part of our story and we want you to be part of the year we mark it.
            </p>
          </div>
          <div className="welcome-stats" style={{
            display: 'grid', gridTemplateColumns: '1fr 1fr',
            gap: '1.5rem', marginTop: '2.5rem',
          }}>
            {[
              { num: '50', label: 'Years of Excellence' },
              { num: '12k+', label: 'Pupils' },
              { num: '8', label: 'Anniversary Events' },
              { num: '1', label: 'Unforgettable Year' },
            ].map((stat, i) => (
              <div className="stat" key={i} style={{
                borderLeft: '2px solid var(--gold)', paddingLeft: '1.2rem',
              }}>
                <div className="num" style={{
                  fontFamily: "'Fraunces', serif", fontWeight: 600,
                  fontSize: '2.5rem', color: 'var(--navy)', lineHeight: 1,
                }}>{stat.num}</div>
                <div className="label" style={{
                  fontSize: '0.75rem', textTransform: 'uppercase',
                  letterSpacing: '0.18em', color: '#666', marginTop: '0.4rem',
                }}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Carousel */}
        <div className="carousel-wrap" id="gallery" style={{ position: 'relative' }}>
          <div className="carousel" style={{
            position: 'relative', aspectRatio: '4/5',
            background: 'var(--navy)', overflow: 'hidden',
            boxShadow: '0 30px 60px rgba(15, 29, 58, 0.25)',
          }}>
            <div className="carousel-frame-label" style={{
              position: 'absolute', top: '1.5rem', left: '1.5rem',
              color: 'var(--gold)', fontSize: '0.7rem',
              letterSpacing: '0.3em', textTransform: 'uppercase',
              zIndex: 3, border: '1px solid var(--gold)',
              padding: '0.4rem 0.8rem',
            }}>Through the Years</div>
            {slides.map((slide, idx) => (
              <div key={idx} className="carousel-slide" style={{
                position: 'absolute', inset: 0,
                opacity: idx === current ? 1 : 0,
                transition: 'opacity 1s ease',
                backgroundImage: `url(${slide})`,
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundColor: 'var(--navy)',
              }} />
            ))}
          </div>
          <div className="carousel-controls" style={{
            display: 'flex', justifyContent: 'space-between',
            alignItems: 'center', marginTop: '1.5rem', padding: '0 0.5rem',
          }}>
            <div className="carousel-dots" style={{ display: 'flex', gap: '0.6rem' }}>
              {slides.map((_, idx) => (
                <button key={idx} className={`dot ${idx === current ? 'active' : ''}`}
                  onClick={() => showSlide(idx)}
                  aria-label={`Slide ${idx + 1}`}
                  style={{
                    width: 30, height: 2,
                    background: idx === current ? 'var(--burgundy)' : 'rgba(15, 29, 58, 0.2)',
                    border: 'none', cursor: 'pointer', transition: 'background 0.3s', padding: 0,
                  }}
                />
              ))}
            </div>
            <div className="carousel-counter" style={{
              fontFamily: "'Fraunces', serif", fontStyle: 'italic',
              color: 'var(--navy)', fontSize: '0.95rem',
            }}>
              <span style={{ color: 'var(--burgundy)', fontWeight: 600 }}>
                {String(current + 1).padStart(2, '0')}
              </span> / {String(total).padStart(2, '0')}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @media (max-width: 960px) {
          .welcome { grid-template-columns: 1fr !important; gap: 3rem !important; }
          .welcome-stats { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
